import ScreenTemplate from "./ScreenTemplate";
import {View} from "react-native";
import styles from "./screen-styles";
import React from "react";

const showBoundaries = null;

export default function ModalScreen({navigation, route}:any) {
  console.log('the props in PricesModal = ', route.params);

  return (
    <ScreenTemplate navigation={navigation} route={route}>

      <View style={[styles.pageContentSlotContainer, showBoundaries]}>

        {route.params.componentToRender ?
          route.params.componentToRender
          : null
        }

      </View>

    </ScreenTemplate>
  )
}
